import { Record as record, List } from 'immutable';

import { construct, fields, resolveAll } from '../../helpers/LinkMapper';
import RefundReason from './Reason';

const defaults = {
    refundValidityDays: 0,
    reasons: new List()
};

class RefundConfig extends record(defaults) {
    static fromJSON (json) {
        return construct(RefundConfig, json, {
            refundValidityDays: fields.number,
            reasons: resolveAll.as(RefundReason)
        });
    }
}

export default RefundConfig;
